module.exports = __webpack_public_path__ + "static/media/email-otp-icon.0b095147.svg";